import { Injectable, Injector } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ForumModel } from './forum.model';
import { FiForumSharedService } from '@fi-shared/fi-forum/fi-forum-shared.service';
import { IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { FicScreenService } from '@fi-shared/fic-screen/fic-screen.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class ForumService extends FiForumSharedService {
    constructor(
        fiBackend: FiBackendService,
        private injector: Injector,
    ) {
        super(fiBackend, injector.get(LoadingService), injector.get(FicScreenService), injector.get(FiStateService));
    }

    getForums(parameterApiModel: IItemsListParameterBase, reqConfig?) {
        return this.fiBackend.fetchObjectsPost('Forum/Forum/GetForums', ForumModel, parameterApiModel, reqConfig);
    }

    getForum(id) {
        return this.fiBackend.fetchObject('Forum/Forum/GetForum/' + id, ForumModel);
    }

    saveForum(forum: ForumModel): Promise<number> {
        return this.fiBackend.fetchDataPost<number>('Forum/Forum/SaveForum', forum);
    }

    /*deleteForumPost(forumPostId) {
        return this.fiBackend.fetchDataPost('Forum/Forum/DeleteForumPost/'+forumPostId);
    }*/

    getForumsForWidget(onlySharedForMe: boolean): Promise<ForumModel[]> {
        const url = 'Forum/Forum/GetForumsForWidget/null/' + onlySharedForMe;
        return this.fiBackend.fetchData(url);
    }

    createInstance() {
        return new ForumModel(undefined, this.injector);
    }
}
